import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { nl2br } from '../../utils/text';

const TrafoTextPreview = (props) => (
    <div
        className={classNames(
            props.className,
            'trafo-text-preview',
            `trafo-text-preview--align--${props.align}`,
            `trafo-text-preview--font--${props.font}`,
            `trafo-text-preview--line-height--${props.lineHeight}`,
        )}
    >
        {props.title ? <h2>{props.title}</h2> : undefined}
        <p>{nl2br(props.text)}</p>
    </div>
);

TrafoTextPreview.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string.isRequired,
    align: PropTypes.string,
    font: PropTypes.string,
    lineHeight: PropTypes.string,
};

TrafoTextPreview.defaultProps = {
    title: undefined,
    className: null,
    align: 'left',
    font: 'sans-small',
    lineHeight: 'small',
};

export default TrafoTextPreview;



// WEBPACK FOOTER //
// ./src/components/arena/TrafoTextPreview.js